import { Box } from '@mui/material';

import { stylesStatusColor, stylesStatusTextOnly } from './styles';
import { BADGE_STATUS_COLOR, BadgeStatusProps } from './types';

export function BadgeStatus(props: BadgeStatusProps) {
  const { statusColor = BADGE_STATUS_COLOR.NONE, label, sx, sxText, textOnly = false, icon } = props;

  return (
    <Box
      sx={{
        ...stylesStatusColor(statusColor),
        ...stylesStatusTextOnly(textOnly),
        ...sx,
      }}
    >
      {icon}
      <Box component='span' sx={sxText}>
        {label}
      </Box>
    </Box>
  );
}
